import { theme as e } from "antd";
const { useToken: t } = e, r = () => {
  const { token: o } = t();
  return { ...o };
};
export {
  r as useColor
};
